<template>
  <div class="new-page">
    <div class="news-wrap">
      <div class="nav-wrap">
        <ul class="nav-list" :class="{ 'have-more': navies.length > 8, 'show-all': showAllNav }">
          <li class="nav-item" :class="{ 'active': activeNav === null }" @click="navChange(null)">
            <img src="@/assets/images/new/ball-all.png" alt="">
            <span>全部</span>
          </li>
          <li class="nav-item" v-for="nav in navies" :key="nav.id"
            :class="{ 'active': activeNav && activeNav.id === nav.id }" @click="navChange(nav)">
            <img :src="nav.img" alt="">
            <span>{{ nav.content }}</span>
          </li>
        </ul>
        <div class="nav-more" :class="{ 'open': showAllNav }" @click="showMoreNav" v-if="navies.length > 8">
          <span>查看更多</span>
          <img src="@/assets/images/new/more@2x.png" alt="">
        </div>
      </div>
      <div class="new-main">
        <div class="main">
          <div class="banner" v-if="banner.length > 0">
            <!-- swiper1 -->
            <swiper class="swiper gallery-top" :options="swiperOptionTop" ref="swiperTop">
              <swiper-slide v-for="(item, idx) in banner" :key="'top' + idx">
                <img :src="item.img" @error="onSwiperCoverError" alt="" @click="goDetail(item)">
                <p>{{ item.title }}</p>
              </swiper-slide>
              <div class="swiper-pagination" slot="pagination"></div>
              <!-- <div class="swiper-button-next swiper-button-white" slot="button-next"></div> -->
              <!-- <div class="swiper-button-prev swiper-button-white" slot="button-prev"></div> -->
            </swiper>
          </div>
          <div class="news-list">
            <div class="news-title">
              体育资讯 <span>Sport News</span>
            </div>
            <ul class="list">
              <li class="new-item" v-for="(newItem, idx) in news" :key="idx" @click="goDetail(newItem)">
                <div class="img">
                  <img :src="newItem.img" @error="onNewsCoverError" alt="">
                </div>
                <div class="info">
                  <p class="title-wrap">
                    <span class="title">{{ newItem.title }}</span>
                  </p>
                  <p class="desc">
                    <template v-if="!activeNav || (activeNav && !activeNav.is_video)">{{ newItem.content |
          formateHtml }}</template>
                  </p>
                  <div class="plays-info">
                    <p class="time">
                      <span class="member-name"
                        v-if="newItem.memberid && newItem.memberid.username">{{ newItem.memberid.username }}</span>
                      <span class="member-name" v-else>用户{{ newItem.member_id }}</span>
                      <img src="@/assets/images/new/time.png" alt="">
                      <span>{{ newItem.created_at | formateTime }}</span>
                    </p>
                    <div class="plays">
                      <div>
                        <img src="@/assets/images/new/zan.png" alt="">
                        <span>{{ newItem.is_like }}</span>
                      </div>
                      <div>
                        <img src="@/assets/images/new/comment.png" alt="">
                        <span>{{ newItem.comments }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
            <div class="empty" v-if="news.length < 1 && pageLoading">
              <img src="//static.vivl1.com/my_no_data.png" alt="">
            </div>
            <div class="pagination-wrap" v-if="news.length > 0">
              <el-pagination background :current-page.sync="page" layout="total, prev, pager, next" prev-text="上一页"
                next-text="下一页" :total="newsTotal" :hide-on-single-page="true" @current-change="handleCurrentChange"
                :page-size="20">
              </el-pagination>
            </div>
          </div>
        </div>
        <div class="section">
          <div class="qr-info">
            <img src="@/assets/images/new/qrcode-info.png" alt="">
          </div>
          <div class="hot-new" v-if="hot.length > 0">
            <p class="title">热门资讯 <span>Hot News</span></p>
            <ul class="list">
              <li v-for="(i, idx) in hot" :key="idx" @click="goDetail(i)">
                <span class="idx">{{ idx + 1 }}</span><span class="content">{{ i.title }}</span>
              </li>
            </ul>
          </div>
          <div class="point-wrap">
            <div class="title">
              <img src="@/assets/images/new/point.png" alt="">
            </div>
            <div class="tabs">
              <ul>
                <li v-for="(tab, idx) in pointTabs" :key="idx"
                  :class="{ 'active': activePointTab === tab.id || (tab.active_id && activePointTab === tab.active_id) }"
                  @mouseenter="changePointTab(tab.id)">
                  {{ tab.name }}
                </li>
              </ul>
            </div>
            <div class="point-list">
              <div class="nba-tab" v-if="[6, 7].includes(activePointTab)">
                <div :class="{ 'active': activePointTab === 6 }" @mouseenter="changePointTab(6)">东部</div>
                <div :class="{ 'active': activePointTab === 7 }" @mouseenter="changePointTab(7)">西部</div>
              </div>
              <ul>
                <li class="title">
                  <div class="top"></div>
                  <div class="team">球队</div>
                  <div class="score">{{ [6, 8].includes(activePointTab) ? "胜/负" : "胜/平/负" }}</div>
                  <div class="point">
                    <template v-if="activePointTab === 7">场均分</template>
                    <template v-else-if="activePointTab === 6">胜场差</template>
                    <template v-else>积分</template>
                  </div>
                </li>
                <li class="team-item" v-for="(point, idx) in activePoints" :key="idx">
                  <div class="rank" :class="{ 'rank-active': idx < 3 }">
                    <img v-if="idx === 0" src="@/assets/images/new/point-one.png" alt="">
                    <img v-if="idx === 1" src="@/assets/images/new/point-two.png" alt="">
                    <img v-if="idx === 2" src="@/assets/images/new/point-three.png" alt="">
                    <span>{{ idx + 1 }}</span>
                  </div>
                  <div class="team">
                    <img :src="point.logo" @error="onAvatarError" alt="">
                    <span v-html="point.team"></span>
                  </div>
                  <div class="score">{{ point.mark }}</div>
                  <div class="point">{{ point.points }}</div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import axios from 'axios'
import dayjs from 'dayjs'
import "dayjs/locale/zh-cn";
import relativeTime from "dayjs/plugin/relativeTime";
dayjs.extend(relativeTime);
dayjs.locale("zh-cn");

export default {
  name: 'NewsPage',
  components: {
    Swiper,
    SwiperSlide
  },
  data() {
    return {
      activeNav: -1,
      windowScrollTop: 0,
      showAllNav: false,
      navies: [],
      banner: [],
      hot: [],
      news: [],
      points: [],
      newsTotal: 0,
      activePointTab: 1,
      pageLoading: false,
      page: 1,
      pointTabs: [
        {
          id: 1,
          name: '中超'
        }, {
          id: 2,
          name: '英超'
        }, {
          id: 3,
          name: '西甲'
        }, {
          id: 4,
          name: '德甲'
        }, {
          id: 5,
          name: '意甲'
        }, {
          id: 6,
          active_id: 7,
          name: 'NBA'
        }, {
          id: 8,
          name: 'CBA'
        },
      ],
      swiperOptionTop: {
        loop: true,
        autoplay: true,
        initialSlide: 0,
        loopedSlides: 3,
        pagination: {
          clickable: true,
          el: '.swiper-pagination'
        },
        // navigation: {
        //   nextEl: '.swiper-button-next',
        //   prevEl: '.swiper-button-prev'
        // }
      }
    }
  },
  computed: {
    activePoints() {
      return this.points[this.activePointTab - 1]
    }
  },
  filters: {
    formateTime: function (val) {
      let time = ''
      if (new Date().getTime() - val * 1000 < 60000) {
        time = '1分钟前'
      } else if (new Date().getTime() - val * 1000 < 86400000) {
        time = dayjs().to(val * 1000);
      } else {
        time = dayjs(val * 1000).format("YYYY-MM-DD HH:MM");
      }
      return time
    },
    formateHtml: function (html) {
      const re1 = new RegExp("<.+?>", "g"); // 匹配html标签的正则表达式，"g"是搜索匹配多个符合的内容
      const msg = html.replace(re1, ''); // 执行替换成空字符
      return msg;
    }
  },
  watch: {
    $route: function (to, from) {
      this.getNewReq()
      if (to.params.navid) {
        this.activeNav = this.navies.filter((nav, idx) => Number(to.params.navid) === nav.id)[0] || null
      } else {
        this.activeNav = null
      }
      if (to.query.page) {
        this.page = Number(to.query.page)
      } else {
        this.page = 1
      }
    }
  },
  methods: {
    showMoreNav() {
      this.showAllNav = !this.showAllNav
    },
    navChange(nav) {
      if (this.activeNav === nav) return
      this.activeNav = nav
      if (!nav) {
        this.$router.push({
          name: 'news'
        })
      } else {
        this.$router.push({
          name: 'sub_news',
          params: {
            navid: nav.id
          }
        })
      }
    },
    getNewReq(query) {
      const params = {}
      let id = this.activeNav ? Number(this.activeNav.id) : null
      if (id) {
        params.id = id === 1 ? '足球' : (id === 2 ? '篮球' : id)
      }
      this.getBanner(query || params)
      this.getNewList(query || params)
      this.getHot(query || params)
    },
    getNewType() {
      const headers = {
        Authorization: this.getCookie("token"),
      };
      axios.get(COMMOND.NEW_BASE_URL + "consultancyWeb", {
        headers: headers,
      }).then((res) => {
        this.navies = res.data.data
        if (this.navies.length > 8) {
          this.showAllNav = false
        }
        if (this.$route.params.navid) {
          this.activeNav = this.navies.filter((nav, idx) => Number(this.$route.params.navid) === nav.id)[0] || null
        } else {
          this.activeNav = null
        }
        this.getNewReq()
      });
    },
    getBanner(params) {
      const headers = {
        Authorization: this.getCookie("token"),
      };
      axios.get(COMMOND.NEW_BASE_URL + "consult_banner_web", {
        headers: headers,
        params
      }).then((res) => {
        this.banner = res.data.data
        if (this.banner.length > 0) {
          if (this.banner.length < 2) {
            this.swiperOptionTop.loop = false
          } else {
            this.swiperOptionTop.loop = true
          }
        }
      });
    },
    getHot(params) {
      const headers = {
        Authorization: this.getCookie("token"),
      };
      axios.get(COMMOND.NEW_BASE_URL + "consult_hot_web", {
        headers: headers,
        params
      }).then((res) => {
        console.log(res)
        this.hot = res.data.data
      });
    },
    getNewList(params) {
      const headers = {
        Authorization: this.getCookie("token"),
      };
      axios.get(COMMOND.NEW_BASE_URL + "consult_list_web?page=" + this.page, {
        headers: headers,
        params
      }).then((res) => {
        this.news = res.data.data.data || []
        this.newsTotal = res.data.data.total || 0
        this.pageLoading = true
      });
    },
    getPointList() {
      const headers = {
        Authorization: this.getCookie("token"),
      };
      axios.get(COMMOND.NEW_BASE_URL + "index", {
        headers: headers
      }).then((res) => {
        this.points = res.data.data
      });
    },
    goDetail(detail) {
      window.open(`/news/detail/${detail.id}`)
      // this.$router.push({
      //   name: 'detail',
      //   params: {
      //     id: detail.id
      //   }
      // })
    },
    changePointTab(id) {
      this.activePointTab = id
    },
    handleCurrentChange(val) {
      const query = {
        page: val
      }
      if (!this.activeNav) {
        this.$router.push({
          name: 'news',
          query
        })
      } else {
        this.$router.push({
          name: 'sub_news',
          params: {
            navid: this.activeNav.id
          },
          query
        })
      }
    },
    //获取cookie值
    getCookie(name) {
      var arr = document.cookie.split("; ");
      for (var i = 0; i < arr.length; i++) {
        var arr2 = arr[i].split("=");
        if (arr2[0] == name) {
          return arr2[1];
        }
      }
      return "";
    }
  },
  mounted() {
    $('.haed_news').addClass('nuxt-link-exact-active');
    this.page = this.$route.query.page ? Number(this.$route.query.page) : 1
    this.getNewType()
    this.getPointList()
  }
}
</script>

<style scoped lang="less">
.new-page {

  background: linear-gradient(#fff, #f5f5f5);
}

.news-wrap {
  width: 1200px;
  margin: 0 auto;

  .nav-wrap {
    display: flex;
    padding: 20px 0;
    align-items: flex-start;
    justify-content: space-between;
  }

  .nav-list {
    display: flex;
    gap: 5px 28px;
    flex-wrap: wrap;
    max-height: 32px;
    transition: max-height 0.75s;
    overflow: hidden;

    &.have-more {
      width: calc(100% - 100px);
    }

    &.show-all {
      max-height: 128px;
    }

    .nav-item {
      display: flex;
      width: 92px;
      align-items: center;
      line-height: 32px;
      color: #4B5B76;
      border-radius: 4px;
      text-align: center;
      justify-content: center;
      font-size: 14px;
      gap: 5px;
      cursor: pointer;

      img {
        width: 20px;
        height: 20px;
      }

      &.active {
        background: #C9353F;
        color: #fff;
      }
    }
  }

  .nav-more {
    display: flex;
    width: 100px;
    align-items: center;
    line-height: 32px;
    color: #4B5B76;
    border-radius: 4px;
    text-align: center;
    justify-content: center;
    font-size: 14px;
    gap: 5px;
    cursor: pointer;

    &.open {
      img {
        transform: rotate(-90deg);
      }
    }

    img {
      width: 20px;
      height: 20px;
      transform: rotate(90deg);
      transition: transform 0.5s;
    }
  }

  .new-main {
    display: flex;
    gap: 20px;
    padding-bottom: 50px;

    .main {
      width: 860px;

      .banner {
        margin-bottom: 30px;

        /deep/ .swiper-pagination-bullets {
          right: 30px;
          bottom: 15px;
          left: auto;
          width: auto;

          .swiper-pagination-bullet-active {
            background-color: #df4655;
          }
        }

        .swiper {
          border-radius: 8px;
          overflow: hidden;

          .swiper-slide {
            border-radius: 8px;
            overflow: hidden;
            position: relative;
            cursor: pointer;

            p {
              position: absolute;
              bottom: 0;
              padding: 10px 20px;
              color: #fff;
              font-size: 16px;
              height: 40px;
              line-height: 20px;
              left: 0;
              right: 150px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }

            img {
              display: block;
              width: 100%;
              height: 100%;
            }
          }

          &.gallery-top {
            height: 480px;
            width: 100%;
          }

          &.gallery-thumbs {
            box-sizing: border-box;
            margin: $gap 0;
            border-radius: 8px;
            overflow: hidden;
          }

          &.gallery-thumbs .swiper-slide {
            width: 280px;
            height: 140px;
            opacity: 0.4;
            border-radius: 8px;
            overflow: hidden;
          }

          &.gallery-thumbs .swiper-slide-active {
            opacity: 1;
          }
        }
      }

      .news-list {
        .news-title {
          color: #13161B;
          font-size: 24px;
          padding-left: 15px;
          line-height: 42px;
          position: relative;
          padding-bottom: 20px;
          border-bottom: 1px solid #EEEEEE;

          &::before {
            content: '';
            position: absolute;
            left: 0;
            width: 6px;
            height: 24px;
            top: 8px;
            background: #C9353F;
            border-radius: 4px;
          }

          span {
            font-size: 16px;
            color: #777;
            margin-left: 15px;
          }
        }

        .list {
          .new-item {
            display: flex;
            padding: 24px 0;
            gap: 24px;
            border-bottom: 1px solid #EEEEEE;
            cursor: pointer;

            &:last-child {
              border: none;
            }

            .img {
              width: 256px;
              height: 144px;
              border-radius: 8px 8px 8px 8px;
              overflow: hidden;

              img {
                display: block;
                width: 256px;
                height: 144px;

                &:hover {
                  transition: all 2s;
                  transform: scale(1.1);
                }
              }
            }

            .info {
              width: 524px;

              .title-wrap {
                font-size: 24px;
                color: #232A35;
                margin-bottom: 14px;
                line-height: 28px;
                display: flex;
                justify-content: space-between;
                gap: 20px;

                .title {
                  flex: 1;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;

                  &:hover {
                    color: #C9353F;
                  }
                }
              }

              .desc {
                font-size: 16px;
                color: #999;
                line-height: 20px;
                height: 40px;
                overflow: hidden;
                margin-bottom: 40px;
                -webkit-line-clamp: 2;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-box-orient: vertical;
              }

              .plays-info {
                display: flex;
                justify-content: space-between;
                color: #777;
                font-size: 14px;
                line-height: 16px;

                .member-name {
                  margin-right: 15px;
                }

                .time {
                  display: flex;
                  align-items: center;

                  img {
                    width: 16px;
                    height: 16px;
                    margin-right: 5px;
                  }
                }

                .plays {
                  display: flex;
                  gap: 20px;

                  div {
                    display: flex;
                    align-items: center;
                  }

                  img {
                    width: 16px;
                    height: 16px;
                    margin-right: 5px;
                  }
                }
              }
            }
          }
        }

        .pagination-wrap {
          display: flex;
          align-items: center;
          justify-content: flex-end;

          /deep/ .el-pagination {
            .el-pager {
              .active {
                background: #C9353F;
              }
            }

            .btn-prev,
            .btn-next {
              padding: 0 8px;
            }
          }
        }
      }
    }

    .section {
      width: 320px;

      .qr-info {
        height: 200px;
        background: #C9353F;
        border-radius: 8px;
        margin-bottom: 24px;

        img {
          width: 208px;
          margin: 16px 38px 10px 74px;
        }
      }

      .hot-new {
        margin-bottom: 24px;

        .title {
          color: #232A35;
          font-size: 24px;
          padding: 20px 16px;
          border-bottom: 1px solid #F3F3F3;
          position: relative;

          &::before {
            content: '';
            position: absolute;
            left: 0;
            width: 6px;
            height: 24px;
            top: 14px;
            background: #C9353F;
            border-radius: 4px;
          }

          span {
            font-size: 16px;
            color: #777;
            margin-left: 15px;
          }
        }

        .list {
          li {
            display: flex;
            padding: 10px 5px;
            font-size: 16px;
            color: #3C485C;
            border-bottom: 1px solid #F3F3F3;
            gap: 10px;
            cursor: pointer;

            &:hover {
              color: #C9353F;
            }

            &:last-child {
              border: none;
            }

            .idx {
              color: #FFCC16;
              width: 24px;
              text-align: center;
            }

            &:nth-child(1) {
              .idx {
                color: #C9353F;
              }
            }

            &:nth-child(2) {
              .idx {
                color: #ED7B2F;
              }
            }

            span {
              line-height: 20px;
            }

            .content {
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
              height: 20px;
              box-sizing: content-box;
              line-height: 20px;
              flex: 1;
            }
          }
        }
      }

      .point-wrap {
        background: #fff;
        padding-bottom: 5px;

        .title {
          img {
            display: block;
            width: 100%;
          }
        }

        .tabs {
          margin: 15px 0;

          ul {
            display: flex;
            justify-content: space-between;

            li {
              height: 24px;
              line-height: 24px;
              padding: 0 8px;
              border-radius: 4px;
              color: #A6A6A6;
              cursor: pointer;
              font-size: 14px;

              &.active {
                background: #C9353F;
                color: #fff;
              }
            }
          }
        }

        .point-list {
          .nba-tab {
            display: flex;

            div {
              flex: 1;
              cursor: pointer;
              font-size: 15px;
              color: #424243;
              text-align: center;
              line-height: 35px;
              background: #f2f2f2;
              border-radius: 4px;
              margin-bottom: 10px;

              &.active {
                background: #C9353F;
                color: #fff;
              }
            }
          }

          li {
            display: flex;
            height: 32px;
            line-height: 32px;
            background: #FBFBFF;
            color: #232A35;
            margin: 0 5px 8px;

            &.title {
              background: #E8F8F2;

              .top {
                width: 50px;
                border: 0px solid transparent;
                border-top: 28px solid #fff;
                border-right: 20px solid transparent;
                filter: drop-shadow(0 0 5px rgba(205, 57, 67, 0.1));
                position: relative;
                left: -6px;
                top: -4px;

                &::after {
                  content: 'TOP';
                  position: absolute;
                  font-weight: bold;
                  width: 50px;
                  left: 6px;
                  top: -30px;
                  color: #B11F26;
                  font-size: 12px;
                }
              }

              .team {
                width: 130px;
              }

              .score {
                width: 60px;
              }

              .point {
                width: 50px;
                margin-left: 15px;
              }
            }

            &:nth-child(2) {
              background: #FDECEE;
            }

            &:nth-child(3) {
              background: #ECF2FE;
            }

            &:nth-child(4) {
              background: #FEF3E6;
            }

            &.team-item {
              .rank {
                width: 40px;

                span {
                  display: inline-block;
                  width: 22px;
                  text-align: center;
                  color: #A6A6A6;
                  font-weight: bold;
                }
              }

              .rank-active {
                position: relative;

                img {
                  width: 40px;
                  height: 24px;
                  position: absolute;
                  left: -9px;
                  top: 4px;
                }

                span {
                  width: 38px;
                  height: 20px;
                  text-align: center;
                  line-height: 20px;
                  position: absolute;
                  left: -9px;
                  top: 4px;
                  color: #fff;
                }
              }

              .team {
                width: 140px;
                display: flex;
                align-items: center;
                gap: 5px;

                img {
                  width: 20px;
                  height: 20px;
                }
              }

              .score {
                width: 60px;
              }

              .point {
                width: 50px;
                margin-left: 15px;
              }
            }
          }
        }
      }
    }
  }
}

.empty {
  img {
    width: 70%;
    margin: 100px auto 0;
    display: block;
  }
}
</style>